







































































import { Component, Mixins, Ref, Vue } from 'vue-property-decorator'
import ModalBase from '@/components/common/molecules/ModalBase.vue'
import ModalBaseMethod from '@/mixins/ModalBaseMethod.vue'
import InputSimple from '@/components/common/atoms/InputSimple.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import CheckboxBase from '@/components/common/atoms/CheckboxBase.vue'
import PaginateButton from '@/components/common/atoms/PaginateButton.vue'
import StudyListForAssignApis, {
  StudyData,
  ModalMarkerType,
  ModalMarkerListType,
} from '@/mixins/requests/admin/StudyListForAssignApis.vue'

@Component({
  components: {
    ModalBase,
    InputSimple,
    ButtonBase,
    CheckboxBase,
    PaginateButton,
  },
})
export default class ModalMarkerAssignSetting extends Mixins(ModalBaseMethod, StudyListForAssignApis) {
  /** Ref: 振分一覧ページネート */
  @Ref() markerListPaginateButton!: PaginateButton

  /** 未振分問題数 */
  private notAssignedCountAll: number | null = null
  /** 全チェック用チェックボックス */
  private isCheckedAll = false

  /** 採点対象設問情報 */
  private modalTargetQuestion: StudyData | null = null
  /** 対象採点者一覧（全件） */
  private modalMarkerList: ModalMarkerListType[] = []
  /** 対象採点者一覧（ページ表示用） */
  private modalMarkerListPaginate: ModalMarkerListType[] = []
  /** 採点者選択チェック一覧 */
  private modalMarkerCheckDatas: string[] = []

  /**
   * モーダル表示初期化時処理
   */
  async init(targetQuestion: StudyData) {
    this.notAssignedCountAll = null
    this.modalTargetQuestion = targetQuestion
    this.modalMarkerList = []
    this.modalMarkerListPaginate = []

    await this.loadMarkerAssignList(false)
  }

  /**
   * モーダル採点者振り分け一覧取得
   */
  async loadMarkerAssignList(parentOnReload: boolean) {
    if (!this.modalTargetQuestion) return false
    this.modalMarkerCheckDatas = []

    Vue.prototype.$loading.start()
    try {
      await this.loadModalMarkerList(
        this.modalTargetQuestion.studyContentId,
        this.modalTargetQuestion.questionId,
        (modalMarkerData: ModalMarkerType) => {
          this.isCheckedAll = false
          this.modalMarkerList = modalMarkerData.markers
          this.notAssignedCountAll = modalMarkerData.notAssignedCountAll
          this.markerListPaginateButton.init(this.modalMarkerList)
          if (parentOnReload) this.$emit('on-reload')
        },
        (err: any) => {
          Vue.prototype.$logger.log(err)
          alert('エラーが発生しました')
        }
      )
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * ページネーション一覧表示更新
   */
  private onClickPaginate(paginateList: ModalMarkerListType[]) {
    // コンポーネントで生成されたリストを表示
    this.modalMarkerListPaginate = paginateList
  }

  /**
   * 採点者担当教科表示
   */
  private makeSubjectName(subjectNames: string[]): string {
    return subjectNames.length == process.env.VUE_APP_MAX_SUBJECT_COUNT ? '全教科' : subjectNames.join('・')
  }

  /**
   * 解答形式表示
   */
  private answerFormatText(): string {
    // TODO: 解答形式の種別仕様が決まり次第実装
    return '記述式'
  }

  /**
   * 振分数入力
   */
  private onInputAssignCount(inputParam: number, event: Event) {
    if (this.notAssignedCountAll === null) return false

    const targetId: string = (event.target as HTMLInputElement).id
    // 入力要素の最大値抑制
    if (this.modalMarkerList && inputParam > this.notAssignedCountAll) {
      const targetNum: number = this.modalMarkerList.findIndex(
        (marker: ModalMarkerListType) => `marker_input_${marker.bcbtCode}` === targetId
      )
      this.modalMarkerList[targetNum].assignCount = this.notAssignedCountAll
    }
  }

  /**
   * リセットボタン（採点者振り分け削除）
   */
  private async onClickResetButton() {
    const checkedMarkerIds = this.modalMarkerList
      .filter((marker: ModalMarkerListType): boolean => marker.isChecked)
      .map((marker: ModalMarkerListType): number => {
        return marker.markerId
      })

    if (checkedMarkerIds.length === 0) {
      alert('チェックボックスを選択してください')
      return false
    }

    if (confirm('振分済みの問題をリセットしますか？')) {
      if (!this.modalTargetQuestion) return false

      Vue.prototype.$loading.start()
      try {
        await this.markerAssignDeleteApi(
          this.modalTargetQuestion,
          checkedMarkerIds,
          async () => {
            await this.loadMarkerAssignList(true)
          },
          (err: any) => {
            if (err.response.data.status === 400) {
              alert(err.response.data.message)
            } else {
              Vue.prototype.$logger.log(err)
              alert('エラーが発生しました')
            }
          }
        )
      } finally {
        Vue.prototype.$loading.complete()
      }
    }
  }

  /**
   * 均等振り分けボタン
   */
  private onClickEqualSettingButton() {
    if (this.notAssignedCountAll === null) return false

    // チェックボックス選択数
    const fractionSize = this.modalMarkerCheckDatas.length
    if (fractionSize === 0) {
      alert('チェックボックスを選択してください')
      return false
    }

    const baseCount = Math.floor(this.notAssignedCountAll / fractionSize)
    let remainderCount = this.notAssignedCountAll % fractionSize

    this.modalMarkerList.map((marker: ModalMarkerListType): void => {
      if (marker.isChecked) {
        marker.assignCount = remainderCount-- > 0 ? Number(baseCount) + 1 : Number(baseCount)
      } else {
        marker.assignCount = 0
      }
    })
  }

  /**
   * 保存ボタン
   */
  private async onClickSaveButton() {
    if (!this.modalTargetQuestion || this.notAssignedCountAll === null) return false

    // 振り分け数合計取得
    const assignCountSum = this.modalMarkerList.reduce(
      (sum: number, marker: ModalMarkerListType) => Number(sum) + Number(marker.assignCount),
      0
    )

    if (assignCountSum === 0) {
      alert('振分数が設定されていません')
      return false
    }

    if (assignCountSum > this.notAssignedCountAll) {
      alert('振分数が未振分問題数を超えています')
      return false
    }

    // 有効な数値が存在する採点者一覧
    const markerAssignListQuery = this.modalMarkerList
      .filter((marker: ModalMarkerListType): boolean => marker.assignCount > 0)
      .map((marker: ModalMarkerListType): { markerId: number; assignmentNumber: number } => {
        return {
          markerId: marker.markerId,
          assignmentNumber: Number(marker.assignCount) + Number(marker.assignedCount),
        }
      })

    Vue.prototype.$loading.start()
    try {
      await this.markerAssignUpdateApi(
        this.modalTargetQuestion,
        markerAssignListQuery,
        async () => {
          await this.loadMarkerAssignList(true)
        },
        (err: any) => {
          if (err.response.data.status === 400) {
            alert(err.response.data.message)
          } else {
            Vue.prototype.$logger.log(err)
            alert('エラーが発生しました')
          }
        }
      )
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * 閉じるボタン
   */
  private onClickCloseButton() {
    this.hide()
    this.$emit('click-close')
  }

  /**
   * 採点者選択全チェック
   */
  private onCheckedMarkerAll(event: PointerEvent) {
    // 全選択用のチェックボックス状態確認
    const checked = (event.target as HTMLInputElement).checked

    this.modalMarkerList.map((marker: ModalMarkerListType): void => {
      // 全体一覧のチェック値反映
      marker.isChecked = checked
      // 採点者ユーザーコードを配列に保持
      if (checked) {
        if (!this.modalMarkerCheckDatas.includes(marker.bcbtCode)) this.modalMarkerCheckDatas.push(marker.bcbtCode)
      } else {
        this.modalMarkerCheckDatas = this.modalMarkerCheckDatas.filter(
          (checkedcbtCode) => checkedcbtCode != marker.bcbtCode
        )
      }
    })
  }

  /**
   * 採点者選択チェック
   */
  private onCheckedMarker(event: PointerEvent) {
    const checked = (event.target as HTMLInputElement).checked
    const bcbtCode = (event.target as HTMLInputElement).value

    // 採点者ユーザーコードを配列に保持
    if (checked) {
      if (!this.modalMarkerCheckDatas.includes(bcbtCode)) this.modalMarkerCheckDatas.push(bcbtCode)
    } else {
      this.modalMarkerCheckDatas = this.modalMarkerCheckDatas.filter((checkedcbtCode) => checkedcbtCode != bcbtCode)
    }
  }
}
